import React from 'react'

/**
 * This function determines if the given react element reference is living inside a fading react-transition-group
 * transition.  Such components remain mounted while transitioning away, and may co-exist on the page with a new
 * version of themselves that is transitioning in.  It is sometimes necessary to determine if you are in such a
 * state before deciding to do take certain actions, such as whether to respond to react-router navigation callbacks
 * @param {React.Ref} ref - the reference of a component to check
 * @return {Boolean} - true if this reference inside a hiding react-transition-group
 */
export function isRefInsideHiddenTransition(
  ref: React.MutableRefObject<HTMLElement | undefined>
): boolean {
  const transitionElement = document.getElementById('app-transition-container')
  if (transitionElement) {
    const transitionChild = transitionElement.firstChild as HTMLElement
    if (transitionChild) {
      const fadeExit = transitionChild.className.includes('fade-exit-active')
      return (
        // if we don't know yet because the reference has not yet been received, assume we will be hidden
        !Boolean(ref.current) ||
        (transitionChild.contains(ref.current as Node) ? fadeExit : !fadeExit)
      )
    }
  }
  // if we get here, react-transition-group is not being used
  return false
}
